<div class="bpt-main-content-container overflow-slider" *ngIf="isScreenAccessible else screenNotAccessible">
                <div *ngIf="documentSearchResult!=undefined && documentSearchResult.length > 0">
                    <app-documents-panel-list #docPanel 
                                              [showLoader] = "showLoader"
                                              [documentSearchResult]=documentSearchResult 
                                              [isShowCheckbox]=displayInActiveButton 
                                              [enableInactiveLabel]=displayInActiveLabel 
                                              (checkboxSelection)="getPanelListData($event)" 
                                              [displayDocumentSelectCheckBoxes]=dispalyCheckBoxes 
                                              [enableFavoriteButton]=enableDocumentFavoriteCheck 
                                              [showInformationIconCheckbox]=displayInformationIconCheckbox
                                              [informationIconTooltip]="informationIconToolTipMessage"></app-documents-panel-list>
                </div>
                <div *ngIf="documentSearchResult==undefined || documentSearchResult.length < 1">
                    You have no favorite documents. Click <a routerLink="/eqms.document">HERE</a> to find some!
                </div>
</div>
<ng-template #screenNotAccessible>
    <app-error [errorMessage]="errorMessage"></app-error>
  </ng-template>